import React, { Component } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import find from 'lodash/find';
import { Form, actions } from 'react-redux-form';
import { Link } from 'react-router-dom';
import Currency from '../Currency';
import {
  tradeSecurityPath,
  tradeOrderTypePath,
  tradeSecurityTransferPath,
} from '../Forms/Schemas/baseRrf';

import BaseDetailScreen from '../BaseDetailScreen';
import Button from '../Button';

import {
  addNotification,
} from '../../actions/notifications';

import {
  createOrder,
} from '../../actions/orders';

import { formatQuantity } from '../SecurityDetail/SecurityDetail';

import { SUPPORT_EMAIL } from '../../actions/urls';
import {
  transferFundsDeposit,
  fetchAccountPositions,
} from '../../actions';
import { errorCodes } from '../TransferFunds/TransferReview';
import Tooltip from '../Tooltip';

import './styles.css';

const getSubHeading = (securityId, tradeDir) => (
  <span styleName="subheading">
    If you experience difficulties, please&nbsp;
    <a
      href={`mailto:${SUPPORT_EMAIL}`}
      styleName="link"
    >
      contact a Client Services representative
    </a>. Execution price, speed and liquidity
    are affected by many factors, including market volatility,
    size, price, low volume, type of order and the exchange the shares are traded on.&nbsp;
    <Link to={`/security-trade/${securityId}/${tradeDir}/order-information-review`} styleName="link">Read more.</Link>
  </span>); // TODO: Read more page/link

class UnconnectedTradeReview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitting: false,
    };
  }
  onSubmit = async () => {
    this.setState({ submitting: true });
    try {
      const {
        tradeSecurityInfo,
        onNext,
        tradeDir,
        tradeSecurityTransferFunds,
        currentAccount,
      } = this.props;
      const {
        ticker,
        limitPrice,
        stopPrice,
        requestedShareAmount,
        term,
      } = tradeSecurityInfo;
      if (tradeSecurityTransferFunds.transferAmount) {
        await this.props.submitTransfer(currentAccount, tradeSecurityTransferFunds);
      } else {
        await this.props.createOrder(tradeDir, ticker, requestedShareAmount, {
          limitPrice,
          stopPrice,
          term,
        });
      }
      await this.props.resetTradeSecurityForm();
      await this.props.resetTradeOrderTypeForm();
      await this.props.resetTradeSecurityTransferForm();
      // Force refresh account positions
      await this.props.fetchAccountPositions(currentAccount, true);
      onNext();
    } catch (err) {
      const { error, errors } = await err.res.json();
      switch (err.res.status) {
        case 400:
          if (error && error.validationErrors
              && Object.keys(error.validationErrors).length > 0) {
            Object.keys(error.validationErrors).forEach((key) => {
              if (error.validationErrors[key].param) {
                this.props.addNotification(`Invalid ${error.validationErrors[key].param}: ${error.validationErrors[key].msg}`);
              } else {
                this.props.addNotification(error.validationErrors[key]);
              }
            });
          } else if (errors && errors.length && errors.length > 0) {
            errors.forEach(thisError => (
              this.props.addNotification(thisError.message || errorCodes[thisError.errorCode])
            ));
          } else {
            this.props.addNotification('Save failed due to invalid data.  Please review your order and try again.');
          }
          break;
        default:
          this.props.addNotification(`Save failed ${err.message}. Please try again later.`);
          break;
      }
      this.setState({ submitting: false });
    }
  }
  render() {
    const {
      securityId,
      tradeDir,
      tradeSecurityInfo,
      tradeSecurityTransferFunds,
      title,
      currentPrice,
      bankLinks,
    } = this.props;
    const {
      submitting,
    } = this.state;
    const {
      ticker,
      typeLabel,
      limitPrice,
      stopPrice,
      requestedShareAmount,
      termLabel,
      term,
      serviceFee,
      total,
    } = tradeSecurityInfo;
    let transferDetails;
    const transferBank = find(bankLinks, { bankLinkOid: tradeSecurityTransferFunds.from });
    let backTo = `/security-trade/${ticker}/${tradeDir}/trade`;
    const isTransfer = !!tradeSecurityTransferFunds.transferAmount;
    if (isTransfer) {
      backTo = `/security-trade/${ticker}/${tradeDir}/payment`;
      transferDetails = (
        <div>
          <div styleName="reviewLabels">From</div>
          <div styleName="reviewFields">{`${transferBank.bankName} ${transferBank.bankAccountNumber}`}</div>
          <div styleName="reviewLabels">To</div>
          <div styleName="reviewFields">My IPO</div>
          <div styleName="reviewLabels">Transfer Amount</div>
          <Currency styleName="reviewAmount" amount={(Number.parseFloat(tradeSecurityTransferFunds.transferAmount))} />
        </div>
      );
    }

    return (
      <BaseDetailScreen
        backLabel={isTransfer ? 'Edit Transfer' : 'Edit Order'}
        backTo={backTo}
        pageHeading={isTransfer ? 'Review Transfer' : title}
        pageSubheading={isTransfer ? '' : getSubHeading(securityId, tradeDir)}
      >
        { isTransfer ?
          <div styleName="transferReview">
            {transferDetails}
            <Form
              onSubmit={this.onSubmit}
              model={tradeSecurityPath}
            >
              <div styleName="submitBtn">
                <Button disabled={submitting} type="submit">Submit</Button>
              </div>
            </Form>
          </div> :
          <div styleName="tradeReview">
            <div styleName="displayRow">
              <div styleName="formLabelNoMargin">Security</div>
              <div styleName="formValue">{ticker}</div>
            </div>
            <Link to={`/security-trade/${securityId}/${tradeDir}/order-type-review`} styleName="formLabelLink">Order Type</Link>
            <div styleName="selectReviewValue">{typeLabel}</div>
            <div styleName="displayRow">
              <div styleName="marketPriceWithTip">
                <div styleName="formLabelNoMargin">Market Price</div>
                <Tooltip text="Market price fluctuates. The value displayed here may not reflect the most recent trade price for this security." />
              </div>
              <Currency styleName="formValue" amount={currentPrice} />
            </div>
            {stopPrice ?
              <div styleName="displayRow">
                <div styleName="formLabelNoMargin">Stop Price</div>
                <Currency styleName="formValue" amount={stopPrice} />
              </div> : null}
            {limitPrice ?
              <div styleName="displayRow">
                <div styleName="formLabelNoMargin">Limit Price</div>
                <Currency styleName="formValue" amount={limitPrice} />
              </div> : null}
            <div styleName="displayRow">
              <div styleName="formLabelNoMargin">Shares</div>
              <div styleName="formValue">{formatQuantity(Number.parseFloat(requestedShareAmount))}</div>
            </div>
            {term ?
              <div>
                <Link to={`/security-trade/${securityId}/${tradeDir}/expiration-review`} styleName="formLabelLink">Expiration</Link>
                <div styleName="selectReviewValue">{termLabel}</div>
              </div> : null}
            <div styleName="breakLineTotal" />
            <div styleName="displayRow">
              <Link to={`/security-trade/${securityId}/${tradeDir}/service-fee-review`} styleName="formLabelLink">Service Fee</Link>
              <Currency styleName="formValue" amount={serviceFee} />
            </div>
            <div styleName="displayRow">
              <div styleName="formLabelNoMargin">Estimated Total</div>
              <Currency styleName="formValue" amount={total} />
            </div>
            <Form
              onSubmit={this.onSubmit}
              model={tradeSecurityPath}
            >
              <div styleName="submitBtn">
                <Button disabled={submitting} type="submit">Submit</Button>
              </div>
            </Form>
          </div>
        }
      </BaseDetailScreen>
    );
  }
}

const mapStateToProps = (state, props) => ({
  bankLinks: get(state, `accountBankLinks.[${state.currentAccount}].data`, []),
  accountBankLinks: get(state, `accountBankLinks.[${props.accountNumber}].data`, []),
  tradeSecurityInfo: get(state, 'tradeSecurityInfo.tradeInfo'),
  tradeSecurityTransferFunds: get(state, tradeSecurityTransferPath),
  currentAccount: state.currentAccount,
});

const mapDispatchToProps = dispatch => ({
  addNotification: (...args) => (dispatch(addNotification(...args))),
  createOrder: (...args) => (dispatch(createOrder(...args))),
  fetchAccountPositions: (...args) => (dispatch(fetchAccountPositions(...args))),
  resetTradeSecurityForm: () => (dispatch(actions.reset(tradeSecurityPath))),
  resetTradeOrderTypeForm: () => (dispatch(actions.reset(tradeOrderTypePath))),
  resetTradeSecurityTransferForm: () => (dispatch(actions.reset(tradeSecurityTransferPath))),
  submitTransfer: (accountNumber, transferInfo) => (
    dispatch(transferFundsDeposit(accountNumber, transferInfo.transferAmount, transferInfo.from))
  ),
});


export default connect(mapStateToProps, mapDispatchToProps)(UnconnectedTradeReview);



// WEBPACK FOOTER //
// ./src/components/SecurityTrade/TradeReview.js